import Preview from 'carbon-react/lib/components/preview';
import styled from 'styled-components';

const Root = styled.div`
  height: 100%;
  padding: 32px 40px;
  width: 100%;
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const PreviewComponent = () => {
  return (
    <Root>
      <Header>
        <Preview height="50px" width="100%" loading />
      </Header>
      <div style={{ display: 'flex', flexDirection: 'row', marginTop: 30 }}>
        <div style={{ height: '100%', marginRight: 30, width: '20%' }}>
          <Preview height="722px" width="100%" loading />
        </div>
        <div style={{ height: '100%', width: '100%' }}>
          <Preview height="722px" width="100%" loading />
        </div>
      </div>
    </Root>
  );
};

export default PreviewComponent;
